import React from 'react'
import { Link } from 'react-router-dom'

const FixedSticky = () => {
  return (
    <Link to='/outsource-your-bottling'>
    <div className='FixedSticky position-fixed flex-center end-0'   data-aos="fade-left"
    data-aos-offset="100"
    data-aos-duration="1000"
    data-aos-once="true"
    data-aos-easing="ease-in-sine">
        <div className='StickyButton'>
           <span className='desktop-show'>OUTSOURCE <br/>
            YOUR BOTTLING</span>
            <span className='mobile-show'>OUTSOURCE YOUR BOTTLING</span>
        </div>
    </div>
    </Link>
  )
}

export default FixedSticky